// Module
var code = "<div class=\"container-fluid\"><uib-tabset active=\"vm.activeTab\"><uib-tab index=\"$index\" ng-repeat=\"tab in vm.tabs\" ui-sref=\"{{tab.uiSref}}\"><uib-tab-heading>{{tab.heading}}</uib-tab-heading></uib-tab></uib-tabset><ui-view></ui-view></div>";
// Exports
var _module_exports =code;;
var path = 'app/views/users/gp-letters/gp-letters.component.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;